/**
 * JUDAM Label Tokens — Status / Category / Informational label colors
 * CRA requires this file inside src/ (cannot import outside src/).
 * Keep in sync with: shared/judam-label-tokens.ts, demopage/src/themes/judam-label-tokens.ts
 */

export const labelColors = {
  status: {
    success: {
      background: '#EDF4E9',
      text: '#4F7A3A',
      border: '#CFE0C5',
    },
    warning: {
      background: '#F8F0E3',
      text: '#8A5819',
      border: '#E6D1AD',
    },
    error: {
      background: '#F8E9E7',
      text: '#A6403C',
      border: '#E8C4C1',
    },
    info: {
      background: '#E8F0F3',
      text: '#315F73',
      border: '#C8D9E0',
    },
    neutral: {
      background: '#EEF1F0',
      text: '#5E6965',
      border: '#D9DFDC',
    },
  },
  category: {
    teal: {
      background: '#E7F2F0',
      text: '#185851',
      border: '#C5DEDA',
    },
    blue: {
      background: '#E8F0F3',
      text: '#315F73',
      border: '#C8D9E0',
    },
    copper: {
      background: '#F5E8DF',
      text: '#7D4529',
      border: '#E4C9B8',
    },
    olive: {
      background: '#EDF2E8',
      text: '#4E6B3A',
      border: '#D2DEC7',
    },
    plum: {
      background: '#F2EAF2',
      text: '#6D4067',
      border: '#DDC9DB',
    },
    neutral: {
      background: '#EEF1F0',
      text: '#5E6965',
      border: '#D9DFDC',
    },
  },
} as const;

export type StatusTone = keyof typeof labelColors.status;
export type CategoryTone = keyof typeof labelColors.category;

export default labelColors;
